import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
import { runExpr } from "expr";
var SinkSelectionPopup = /** @class */ (function (_super) {
    tslib_1.__extends(SinkSelectionPopup, _super);
    function SinkSelectionPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SinkSelectionPopup.prototype.setSink = function (sink) {
        if (!this.isActive(sink))
            return;
        var sinkWasNull = this.$state.sink == null;
        var hobcutoutDistanceLeft = this.$ui.hobcutoutDistanceLeft;
        var positionNeedsUpdate = !sinkWasNull && this.$state.sinkHandedness != sink.handedness;
        this.$state.sink = sink.code;
        this.$state.sinkHandedness = sink.handedness;
        this.$state.sinkDistanceX = null;
        this.$state.faucetHole = "0";
        this.$state.extraHoleCode = "0";
        if (positionNeedsUpdate && this.$state.hobcutout == "1") {
            //this.$ui.sinkDistanceLeft = sinkDistanceLeft;
            this.$ui.hobcutoutDistanceLeft = hobcutoutDistanceLeft;
        }
        this.$emit("update:visible", false);
        //Skip sink step if user has chosen "no sink"
        if (sinkWasNull && !this.$ui.sink.hasDimensions)
            this.$router.push("/hobcutout");
    };
    SinkSelectionPopup.prototype.getMessages = function (sink) {
        var e_1, _a;
        var messages = [];
        if (sink.rules) {
            try {
                for (var _b = tslib_1.__values(sink.rules), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var rule = _c.value;
                    var enabled = runExpr({
                        state: this.$state,
                        ui: this.$ui,
                        selfKey: "sink"
                    }, rule.expression);
                    if (!enabled && messages.indexOf(rule.resourceKey) == -1) {
                        messages.push(rule.resourceKey);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return messages;
    };
    SinkSelectionPopup.prototype.isActive = function (sink) {
        return this.getMessages(sink).length == 0;
    };
    SinkSelectionPopup.prototype.getCssClasses = function (sink) {
        var selectedSinks = this.$configuration.models.sinks.filter(function (s) { return s.code == sink.code; });
        return {
            active: this.$state.sink == sink.code && (this.$state.sinkHandedness == sink.handedness || selectedSinks.length == 1),
            disabled: !this.isActive(sink)
        };
    };
    SinkSelectionPopup.prototype.close = function () {
        this.$emit("update:visible", false);
    };
    tslib_1.__decorate([
        Prop({ type: Boolean, default: false }),
        tslib_1.__metadata("design:type", Boolean)
    ], SinkSelectionPopup.prototype, "visible", void 0);
    SinkSelectionPopup = tslib_1.__decorate([
        Component
    ], SinkSelectionPopup);
    return SinkSelectionPopup;
}(Vue));
export default SinkSelectionPopup;
